import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const TrackOrderPage = () => {
  const [email, setEmail] = useState('');
  const [orderId, setOrderId] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // In production, this would call API to verify order
    // For now, navigate with params
    if (!email || !orderId) {
      setError('Please enter both email and order ID');
      return;
    }

    navigate(`/order-status?email=${encodeURIComponent(email)}&orderId=${orderId}`);
  };

  return (
    <div className="track-order-page">
      <div className="track-order-container">
        <h1>📦 Track Your Order</h1>
        <p className="track-subtitle">Enter your email and order ID to view your order details</p>

        <form onSubmit={handleSubmit} className="track-form">
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Order ID</label>
            <input
              type="text"
              placeholder="e.g., ORD-12345"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              required
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="track-btn">Track Order</button>
        </form>

        <div className="track-help">
          <p>💡 You can find your Order ID in the confirmation email we sent you.</p>
        </div>
      </div>
    </div>
  );
};

export default TrackOrderPage;
